import type { AlertEvent, Severity } from "./alert-model.js";

export interface AlertSurfaces {
  toast(ev: AlertEvent): void;
  takeover(ev: AlertEvent): void;
}
const RANK: Record<Severity, number> = { info: 1, warning: 2, critical: 3 };

/** Routes engine events to UI surfaces. Per-bucket threshold determines whether
 *  a bucket is muted ("off"), shown on info+, warning+, or always takeover (critical).
 *  allClear is always a gentle toast regardless of bucket level.
 *  critical always breaks through as a takeover unless the bucket is "off". */
export function makeAlertController(
  surfaces: AlertSurfaces,
  opts: { level?: (bucket: string) => "off" | "info" | "warning" | "critical" } = {},
): { route(events: AlertEvent[]): void } {
  const level = opts.level ?? (() => "warning");
  return {
    route(events) {
      for (const e of events) {
        if (e.kind === "allClear") { surfaces.toast(e); continue; }
        const thr = level(e.hazard);           // e.hazard is the display bucket (F0b)
        if (thr === "off") continue;           // muted: no toast, no takeover
        if (e.severity === "critical") { surfaces.takeover(e); continue; }
        if (RANK[e.severity] >= RANK[thr as Severity]) surfaces.toast(e);
      }
    },
  };
}
